export enum USER_STATES {
  checkPreFetchedCreditLimit = 'CHECK_PRE_FETCHED_CREDIT_LIMIT', // comp: home page api: /api/v1/money/check-prefetched-limit
  applicantLookUp = 'APPLICANT_LOOK_UP', // comp: personal details api: /api/v1/money/validate-customer
  addPersonalDetails = 'ADD_PERSONAL_DETAILS', // comp: personal details api: /api/v1/money/add-personal-details
  startKyc = 'START_KYC', // comp: address details  api: /api/v1/money/perform-kyc
  startOkyc = 'START_OKYC', // comp: address details api: /api/v1/money/perform-okyc
  startFaceMatch = 'START_FACE_MATCH',
  sendOkycOtp = 'SEND_OKYC_OTP', // comp: address details api: /api/v1/money/okyc-generate-otp
  verifyOkycOtp = 'VERIFY_OKYC_OTP', // comp: address details api: /api/v1/money/okyc-verify-otp
  addAddressDetails = 'ADD_ADDRESS_DETAILS', // comp: address details api: /api/v1/money/add-address-details
  addEmploymentDetails = 'ADD_EMPLOYMENT_DETAILS', // comp: professional details api: /api/v1/money/add-employment-details
  getCreditLimit = 'GET_CREDIT_LIMIT', // comp: credit limit api: /api/v1/money/get-credit-limit
  addBankingDetails = 'ADD_BANKING_DETAILS', // comp: bank details api: /api/v1/money/add-banking-details
  initiateMandate = 'INITIATE_MANDATE', // comp: bank details api: /api/v1/money/sign-mandate
  checkMandateStatus = 'CHECK_MANDATE_STATUS', // comp: check mandate status  api: /api/v1/money/check-mandate-status
  initiateDrawdown = 'INITIATE_DRAWDOWN', // comp: check mandate status api: /api/v1/money/initiate-drawdown
  fetchAgreement = 'FETCH_AGREEMENT', // comp: loan agreement api: /api/v1/money/fetch-agreement
  sendAgreementOtp = 'SEND_AGREEMENT_OTP', // comp: loan agreement api: /api/v1/money/send-agreement-otp
  verifyAgreementOtp = 'VERIFY_AGREEMENT_OTP', // comp: loan agreement api: /api/v1/money/verify-agreement-otp
  drawdownDetails = 'DRAWDOWN_DETAILS', // comp: credit status api: /api/v1/money/get-user-drawdowns
  pollingApi = 'START_POLLING',
  pullSchedules = 'PULL_SCHEDULES',
  VKyc = 'V_KYC',
}
